import { StyleRules } from '@material-ui/core/styles';
import { TooltipClassKey } from '@material-ui/core/Tooltip';
import { core as theme } from '../styles/core';

export const MuiTooltip: Partial<StyleRules<TooltipClassKey>> = {
  arrow: {
    color: theme.palette.grey[700],
  },
  tooltip: {
    backgroundColor: theme.palette.grey[700],
    boxShadow:
      '0px 1px 2px rgba(69, 69, 69, 0.1), 0px 1px 4px rgba(69, 69, 69, 0.2)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.6,
    padding: 8,
  },
};
